import { useState } from "react";
import axios from "axios";
import { api } from "../api";

export default function Register() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("tech"); // valor padrão
  const [message, setMessage] = useState("");

  const handleRegister = async () => {
    if (!username || !password || !role) {
      return setMessage("Preencha todos os campos.");
    }

    try {
        await api.post("/auth/register", {
        username,
        password,
        role
      });

      setMessage("Usuário cadastrado com sucesso!");
      setUsername("");
      setPassword("");
      setRole("tech");
    } catch (err) {
      console.error(err);
      setMessage("Erro ao cadastrar usuário.");
    }
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      background: "#f5f5f5"
    }}>
      <div style={{
        background: "#fff",
        padding: 30,
        borderRadius: 8,
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        width: 300
      }}>
        <h2 style={{ textAlign: "center", marginBottom: 20 }}>Cadastro</h2>

        <input
          type="text"
          placeholder="Usuário"
          value={username}
          onChange={e => setUsername(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />
        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />
        <select
          value={role}
          onChange={e => setRole(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        >
          <option value="admin">Admin</option>
          <option value="tech">Técnico</option>
          <option value="viewer">Visualizador</option>
        </select>

        <button
          onClick={handleRegister}
          style={{
            width: "100%",
            padding: 10,
            background: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer"
          }}
        >
          Cadastrar
        </button>

        {message && <p style={{ marginTop: 10, textAlign: "center" }}>{message}</p>}
      </div>
    </div>
  );
}
